document.addEventListener('DOMContentLoaded', function () {

  let  checkoutBtnFound = false;
     


const observer = new MutationObserver(() => {
    document.querySelectorAll(".wizz-product-subcription-name-custom").forEach(header => {
      if (header.textContent.trim() === "Dropstreet Reminders") {
        const groupWrapper = header.closest(".w4-flex.w4-flex-col");
        if (groupWrapper) {
          groupWrapper.style.display = "none"; // only hide THIS group
        }
      }
    });

     // this is for allowing coupons to work
      const checkoutButton = document.querySelector('.wizz-checkout-link');

       if (checkoutButton && !checkoutBtnFound) {
        checkoutBtnFound = true;
        checkoutButton.addEventListener('click', async function (e) {

       
          console.log("button clicked");
          e.preventDefault();
    
          try {
            const cartResponse = await fetch('/cart.js');
            const cart = await cartResponse.json();
    
            const WEEK_PLAN_GROUP_ID = 338257674417; // ← your real Week Plan group ID here
    
            for (const item of cart.items) {
              const productId = item.product_id;
              const sellingPlanAllocation = item.selling_plan_allocation;
    
            
    
              const isOneTimePurchase = typeof sellingPlanAllocation === 'undefined';
              console.log ("isOneTimePurchase "+isOneTimePurchase);
              const isSmsReminderSubscription = sellingPlanAllocation?.selling_plan?.name?.includes("SMS Reminder");
    
              if (isOneTimePurchase || isSmsReminderSubscription) {
                console.log("Adding product to Reminders collection:", productId);
                await fetch(`https://shop-app.dropstreet.co/public/product-to-collection.php?shop=aldos-coffee-company-2.myshopify.com&product_id=${encodeURIComponent(productId)}`);
              } else {
                console.log("Skipping product:", productId);
              }
            }
    
            // Redirect to checkout
            window.location.href = '/checkout';
    
          } catch (error) {
            console.error('Error before checkout:', error);
            alert('Something went wrong while preparing your checkout.');
          }
        });
      }else{
         //console.log("no checkout button found");
      }
  



  });

  observer.observe(document.body, { childList: true, subtree: true });



 const DISABLED_FLAG = "disabledUpsellProcessed";

  function shouldDisable(el) {
    // Use innerText so we check the visible label
    const text = (el.innerText || el.textContent || "").trim();
    return /sms\s+reminder/i.test(text);
  }

  function disableDropdown(el) {
    if (!el || el.dataset[DISABLED_FLAG] === "1") return;

    // Make it look/act disabled
    el.style.pointerEvents = "none";
    el.style.opacity = "0.9";
    el.style.cursor = "not-allowed";
    el.setAttribute("aria-disabled", "true");
    el.setAttribute("tabindex", "-1");

    // Block any app handlers (capture phase)
    ["click","pointerdown","mousedown","touchstart","keydown"].forEach(evt => {
      el.addEventListener(evt, e => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
      }, true);
    });

    // Hide arrow SVG (and its wrapper)
    const arrowSvg = el.querySelector("svg");
    if (arrowSvg) {
      const wrap = arrowSvg.parentElement || arrowSvg;
      wrap.style.display = "none";
    }

    el.dataset[DISABLED_FLAG] = "1";
  }

  function evaluateAndDisable(el) {
    if (!el) return;
    // If it contains "SMS Reminder", disable it
    if (shouldDisable(el)) {
      disableDropdown(el);
    }
  }

  function scanAll() {
    // Attribute selector catches ALL nodes even if IDs are duplicated
    document.querySelectorAll("[id='w4-select-upsell']").forEach(el => {
      evaluateAndDisable(el);

      // Watch each dropdown for label changes (e.g., selection changes)
      if (!el.dataset.observeText) {
        const textObserver = new MutationObserver(() => evaluateAndDisable(el));
        textObserver.observe(el, { childList: true, subtree: true, characterData: true });
        el.dataset.observeText = "1";
      }
    });
  }

  // Initial pass
  scanAll();

  // Observe future injections/re-renders
  const observer2 = new MutationObserver((mutations) => {
    let needsScan = false;
    for (const m of mutations) {
      // Quick checks to avoid heavy scanning every time
      for (const node of m.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.id === "w4-select-upsell" || node.querySelector?.("[id='w4-select-upsell']")) {
          needsScan = true;
          break;
        }
      }
      if (needsScan) break;
    }
    if (needsScan) scanAll();
  });
  observer2.observe(document.body, { childList: true, subtree: true });



});
